// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TextArea } from 'informed';

import {
  addOtherImagingReport,
  deleteOtherImagingReport,
  updateOtherImagingReport,
} from '../../../actions/externalReportsActions';

import DateText from '../../DateText.jsx';
import ValidateText from '../../ValidateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';
import { Button } from '../../Buttons.jsx';

type Props = {
  otherImagingReports: Object[],
  activePatientId: string,
  addOtherImagingReport: Function,
  deleteOtherImagingReport: Function,
  updateOtherImagingReport: Function,
}

class OtherImagingReportsComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteOtherImagingReport(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateOtherImagingReport(this.props.activePatientId, {
      reportId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addOtherImagingReport(this.props.activePatientId, formData.values);
  }

  render() {
    const { otherImagingReports } = this.props;

    const columns = [
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
        width: 100,
      },
      {
        Header: 'Document Name',
        id: 'name',
        editCell: item => <Typeahead field='name' initialValue={item.name} endpoint='docName' />,
      },
      {
        Header: 'Summary',
        id: 'summary',
        editCell: item => <TextArea field='summary' initialValue={item.summary} />,
      },
      {
        Header: 'Author/Location',
        id: 'location',
        editCell: item => <Typeahead field='location' initialValue={item.location} endpoint='reportLocation' />,
      },
      {
        Header: 'Link',
        id: 'link',
        cell: (item) => {
          if (!item.link) {
            return '--';
          }
          let { link } = item;
          if (link.indexOf('http') === -1) {
            link = `http://${link}`;
          }
          return <a target='_blank' rel='noopener noreferrer' href={link}><Button>Open Link</Button></a>;
        },
        editCell: item => <ValidateText
          field='link'
          initialValue={item.link}
          placeholder='e.g. Google Drive link'
          regex={/^(https?:\/\/.*)?$/}
          errorText='Improper URL, please use http://...'
        />,
        width: 150,
      },
    ];

    return (
      <Table
        columns={columns}
        data={otherImagingReports}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  otherImagingReports: state.patient.data.externalReports.otherImagingReports,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addOtherImagingReport:
    (patientId, otherImagingReport) => dispatch(addOtherImagingReport(patientId, otherImagingReport)),
  deleteOtherImagingReport:
    (patientId, otherImagingReportId) => dispatch(deleteOtherImagingReport(patientId, otherImagingReportId)),
  updateOtherImagingReport:
    (patientId, otherImagingReport) => dispatch(updateOtherImagingReport(patientId, otherImagingReport)),
});

const OtherImagingReports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OtherImagingReportsComponent);

export default OtherImagingReports;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/externalReports/OtherImagingReports.jsx